import React from "react";
import loadJs from '../utils/load-js';
import {gaEvent} from '../utils/ga'


export default class MailchimpScripts extends React.Component {
  render() {
    return null;
  }

  componentDidMount() {
    loadJs({
      url: 'https://s3.amazonaws.com/downloads.mailchimp.com/js/signup-forms/popup/embed.js',
      createFunc: scriptTag => {
        scriptTag.dataset['dojoConfig'] = 'usePlainJson: true, isDebug: false';
      }
    }).then(() => {
      window.require(["mojo/signup-forms/Loader"], (L) => {
        this.L = L;
      });
    });
  }

  // https://gist.github.com/scottmagdalein/259d878ad46ed6f2cdce
  open() {
    gaEvent('mailinglist', 'popup-open');
    document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
    this.L.start({"baseUrl":"mc.us14.list-manage.com","uuid":"2eb5079cc9179616cde242578","lid":"e255b328f5"});
    document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  }
}


// WEBPACK FOOTER //
// ./src/components/MailchimpScripts.js